/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { M2MClientsPage } from '@/pages/M2MClients/M2MClientsPage';

export function M2MClientsRoute() {
  return <M2MClientsPage />;
}
